import React from 'react';
import { SYSTEM_ICON_SIZES } from '../../constants';
import { getStrokeColor } from '../../utils';
import type { SystemIconType } from '../../types';

const StarIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      stroke={getStrokeColor(color)}
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.36 1.93a.717.717 0 0 1 1.28 0l1.568 3.078c.104.205.3.347.526.383l3.41.543c.579.092.81.8.396 1.215l-2.442 2.448a.72.72 0 0 0-.2.618l.538 3.417a.717.717 0 0 1-1.034.75l-3.076-1.567a.72.72 0 0 0-.652 0l-3.076 1.567a.717.717 0 0 1-1.034-.75l.538-3.417a.72.72 0 0 0-.2-.618L1.46 7.149a.717.717 0 0 1 .395-1.215l3.41-.543a.72.72 0 0 0 .527-.383z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
StarIcon.id = 'StarIcon';
StarIcon.displayName = 'StarIcon';
export default StarIcon;
